export const PlayCircle = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 4C7.58885 4 4 7.58885 4 12C4 16.4112 7.58885 20 12 20C16.4112 20 20 16.4112 20 12C20 7.58885 16.4112 4 12 4ZM14.8758 12.3577L10.4738 15.0169C10.4108 15.0547 10.3387 15.0751 10.2652 15.0758C10.1916 15.0766 10.1192 15.0578 10.0553 15.0214C9.99143 14.9849 9.93839 14.9322 9.90163 14.8684C9.86487 14.8047 9.84573 14.7324 9.84615 14.6588V9.34115C9.84573 9.2676 9.86487 9.19526 9.90163 9.13155C9.93839 9.06784 9.99143 9.01506 10.0553 8.97861C10.1192 8.94216 10.1916 8.92337 10.2652 8.92416C10.3387 8.92494 10.4108 8.94528 10.4738 8.98308L14.8758 11.6423C14.9371 11.6797 14.9878 11.7322 15.023 11.7949C15.0582 11.8575 15.0767 11.9282 15.0767 12C15.0767 12.0718 15.0582 12.1425 15.023 12.2051C14.9878 12.2678 14.9371 12.3203 14.8758 12.3577Z"
        fill="currentColor"
      />
    </svg>
  );
};
